window.onload = function () {
  const currentURL = new URL(window.location.href);
  const experienceTypeSelect = document.querySelector('.experiences__filter-select');

  experienceTypeSelect.addEventListener('change', (e) => {
    e.preventDefault();
    const key = 'experience-type';
    const experienceType = experienceTypeSelect.value;
    if (experienceType.length === 0) {
      return false;
    }

    if (experienceType === 'all') {
      currentURL.searchParams.delete(key);
    } else {
      currentURL.searchParams.set(key, experienceType);
    }
    window.location.href = currentURL.toString();
    return true;
  });
};
